window.AAWorkspaceAuth = (() => {
  const LOGIN_ROUTE = '/pages/workspace-login';

  function getClient() {
    return window.AASupabaseClient?.getClient?.() || null;
  }

  function getMessage(error) {
    if (!error) return '';

    const message = error.message || '';

    if (message.toLowerCase().includes('invalid login')) {
      return 'The email or password is incorrect.';
    }

    if (message.toLowerCase().includes('email not confirmed')) {
      return 'Please confirm your email before signing in.';
    }

    return 'Unable to sign in. Please try again.';
  }

  function setMessage(messageEl, text) {
    if (!messageEl) return;

    messageEl.textContent = text || '';
    messageEl.hidden = !text;
  }

 function showEntryStep(step) {
  const steps = document.querySelectorAll('[data-aa-entry-step]');

  steps.forEach((item, index) => {
    item.classList.remove('is-active');
    item.classList.remove('is-complete');

    if (index < step) {
      item.classList.add('is-complete');
    } else if (index === step) {
      item.classList.add('is-active');
    }
  });
}

function showEntryTransition(name = 'Tiffany') {
  let transition = document.querySelector('[data-aa-entry-transition]');

  if (transition) {
    transition.hidden = false;
    return transition;
  }

  transition = document.createElement('div');
  transition.className = 'aa-entry-transition';
  transition.setAttribute('data-aa-entry-transition', '');

  transition.innerHTML = `
    <div class="aa-entry-transition__card">

      <div class="aa-entry-transition__brand">Artisan’s Avenue</div>

      <h2>Welcome back, ${name}.</h2>

      <div class="aa-entry-transition__steps">

        <p class="is-active" data-aa-entry-step>
          <span class="aa-entry-spinner"></span>
          Verifying your account
        </p>

        <p data-aa-entry-step>
          <span class="aa-entry-spinner"></span>
          Loading your Workspace
        </p>

        <p data-aa-entry-step>
          <span class="aa-entry-spinner"></span>
          Preparing your dashboard
        </p>

        <p data-aa-entry-step>
          <span class="aa-entry-spinner"></span>
          Opening your Workspace...
        </p>

      </div>

    </div>
  `;

  document.body.appendChild(transition);
  return transition;
}

  function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async function handleLogin(form) {
    const db = getClient();
    const emailInput = form.querySelector('[data-aa-login-email]');
    const passwordInput = form.querySelector('[data-aa-login-password]');
    const submitButton = form.querySelector('[data-aa-login-submit]');
    const messageEl = form.querySelector('[data-aa-login-message]');

    if (!db) {
      setMessage(messageEl, 'Workspace login is not available right now.');
      return;
    }

    const email = emailInput?.value?.trim();
    const password = passwordInput?.value || '';

    if (!email || !password) {
      setMessage(messageEl, 'Enter your email and password.');
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = 'Signing in...';
    setMessage(messageEl, '');

    try {
      showEntryTransition('Tiffany');
      showEntryStep(0);

      const { error } = await db.auth.signInWithPassword({
        email,
        password
      });

      if (error) {
        document.querySelector('[data-aa-entry-transition]')?.remove();
        submitButton.disabled = false;
        submitButton.textContent = 'Sign In';
        setMessage(messageEl, getMessage(error));
        return;
      }

      await wait(350);
      showEntryStep(1);

      await wait(350);
showEntryStep(2);

const route = '/pages/workspace-dashboard';

      await wait(350);
      showEntryStep(3);

      await wait(450);
      window.location.assign(route);
    } catch (error) {
      document.querySelector('[data-aa-entry-transition]')?.remove();
      submitButton.disabled = false;
      submitButton.textContent = 'Sign In';
      setMessage(messageEl, 'Unable to open your Workspace. Please try again.');
      console.error('AA login redirect error:', error);
    }
  }

  async function handleForgotPassword(button) {
    const db = getClient();
    const root = button.closest('[data-aa-auth-login]');
    const emailInput = root?.querySelector('[data-aa-login-email]');
    const messageEl = root?.querySelector('[data-aa-login-message]');
    const email = emailInput?.value?.trim();

    if (!db) {
      setMessage(messageEl, 'Password reset is not available right now.');
      return;
    }

    if (!email) {
      setMessage(messageEl, 'Enter your email first, then click Forgot Password.');
      return;
    }

    button.disabled = true;
    button.textContent = 'Sending reset link...';

    const { error } = await db.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}${LOGIN_ROUTE}`
    });

    button.disabled = false;
    button.textContent = 'Forgot Password?';

    if (error) {
      setMessage(messageEl, 'Unable to send reset link. Please try again.');
      return;
    }

    setMessage(messageEl, 'Password reset link sent. Check your email.');
  }

  function bindLoginPage() {
    const root = document.querySelector('[data-aa-auth-login]');
    if (!root) return;

    const form = root.querySelector('[data-aa-login-form]');
    const forgotButton = root.querySelector('[data-aa-forgot-password]');

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        handleLogin(form);
      });
    }

    if (forgotButton) {
      forgotButton.addEventListener('click', () => {
        handleForgotPassword(forgotButton);
      });
    }
  }

  function init() {
    bindLoginPage();
  }

  return {
    init
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  window.AAWorkspaceAuth?.init?.();
});